import e from "react";
//#region src/services/focusRestore/FocusRestoreContext.ts
var t = e.createContext(void 0);
//#endregion
export { t as FocusRestoreContext };
